import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';



@Component({
  selector: 'app-table',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {
  @ViewChild('filters') filtersBar!: ElementRef;
  @Input() statusFilters: any[] = [];
  @Input() activeStatus = 'all';
  @Input() showSearch = true;
  @Input() searchPlaceholder = 'Search...';

  @Output() statusChange = new EventEmitter<string>();
  @Output() searchChange = new EventEmitter<string>();

  searchTerm = '';

  onStatusClick(key: string): void {
    this.activeStatus = key;
    this.statusChange.emit(key);
  }

  onSearchChange(value: string): void {
    this.searchChange.emit(value);
  }
}